import FlightSearchPage from './FlightSearchPage'

export default FlightSearchPage
